module.exports = __webpack_public_path__ + "img/iconfont.db2afa7e.svg";